import EventBus from '_lib/EventBus'
import { clearUserInFriendsRoom } from '_lib/utils/utilsFriend'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import {
  isSingleUser
} from "_lib/utils/utilsFriend";
import steam from '_lib/steam';
import { SOCKET_FRIEND_UPDATE_ALT_TYPE } from '@/common/constants/friend';
// 好友列表增量更新逻辑处理，单独抽离出来
export default {
  mounted() {
    // 好友列表局部更新
    EventBus.$on('SOCKET_FRIENDS_STATE_UPDATE', this.updateFriendList)
  },
  beforeDestroy() {
    EventBus.$off('SOCKET_FRIENDS_STATE_UPDATE', this.updateFriendList)
  },
  computed: {
    ...mapGetters([
      'friends_map'
    ])
  },
  methods: {
    updateFriendList(data) {
      let d = data.data, alt_type = d.alt_type, type, friend_data, user_id
      if (d.friends && d.friends.length > 0) {
        friend_data = d.friends[0]
        type = 'friends'
        user_id = friend_data.user_id
      } else {
        try {
          friend_data = d.rooms[0]
          user_id = friend_data.channels[0].friends[0].user_id
          type = 'rooms'
        } catch (e) {
          console.log(e)
        }
      }

      // 无论是增加删除还是改变，都先清理掉历史的同用户数据
      // 防止乱序导致数据重复
      this.clearUpdateFriend(user_id)
      if (alt_type !== SOCKET_FRIEND_UPDATE_ALT_TYPE.DELETE) {
        this.addUpdateFriend(friend_data, type)
      }

      // 收到推送时更新friends_map对象，否则在很多地方判断是否是好友时会出问题
      if (alt_type === SOCKET_FRIEND_UPDATE_ALT_TYPE.DELETE) {
        this.$delete(this.friends_map, friend_data.user_id)
      } else {
        if (type === 'friends') {
          this.$set(this.friends_map, user_id, friend_data)
        } else {
          this.$set(this.friends_map, user_id, friend_data.channels[0].friends[0])
        }
      }
    },
    clearUpdateFriend(user_id) {
      // 如果删除的用户在online_friends或offline_friends数组中，直接清除
      let online_index = this.friends_data.online_friends.findIndex(friend => friend.user_id === user_id)
      if (online_index >= 0) {
        this.friends_data.online_friends.splice(online_index, 1)
        return
      }

      let offline_index = this.friends_data.offline_friends.findIndex(friend => friend.user_id === user_id)
      if (offline_index >= 0) {
        this.friends_data.offline_friends.splice(offline_index, 1)
        return
      }

      // 尝试从rooms数组中清除此用户数据
      let room = clearUserInFriendsRoom(this.friends_data.rooms, user_id)
      // 返回room说明此用户在rooms数组中
      if (room) {
        // 删除此用户后，room如果只有一个用户，需要转移到single_user_rooms数组中
        if (isSingleUser(room.channels)) {
          let room_index = this.friends_data.rooms.findIndex(r => r === room)
          this.friends_data.rooms.splice(room_index, 1)

          this.friends_data.single_user_rooms.push(room)
          this.friends_data.single_user_rooms.sort(this.friendRoomAndChannelSortFunc)
        }
        return
      }

      clearUserInFriendsRoom(this.friends_data.single_user_rooms, user_id)
    },
    addUpdateFriend(data, type) {
      if (type === 'friends') {
        // 新增好友不在房间里，直接根据在线状态添加到对应数组并排序
        if (data.state == 0) {
          this.friends_data.offline_friends.push(data)
          this.friends_data.offline_friends.sort(this.friendSortFunc)
        } else {
          this.friends_data.online_friends.push(data)
          this.friends_data.online_friends.sort(this.friendSortFunc)
        }
        
        const steamResultList = steam.formatResultList(steam.resultList, [data])
        this.$set(this.friends_data, 'steam_friends', steamResultList)
      } else {
        // 新增好友在房间里，需要判断和移动好友房间数据
        let room_id = data.room_id, 
        channel_id = data.channels[0].channel_id,
        room_info = data,
        channel_info = data.channels[0],
        friend_info = channel_info.friends[0]

        // 将好友添加到已有房间数据中的函数
        let addFriendToRoom = (room, channel_id) => {
          if (!room.channels) return
          let channel_index = room.channels.findIndex((channel) => channel.channel_id === channel_id)
          if (channel_index >= 0) {
            let channel = room.channels[channel_index]
            let friends = channel.friends
            friends.push(friend_info)
            friends.sort(this.friendSortFunc)
            // channel其他数据替换为推送中的新数据，friends取原有数据和推送数据的合并
            this.$set(room.channels, channel_index, {
              ...channel_info,
              friends
            })
          } else {
            // 如果不是已有的channel数据，直接新增channel并排序
            room.channels.push(channel_info)
            room.channels.sort(this.friendRoomAndChannelSortFunc)
          }
        }

        // 1. 判断新增好友所在房间是不是好友rooms数据中的已有房间
        let room_index = this.friends_data.rooms.findIndex(v => v.room_id === room_id)
        if (room_index >= 0) {
          let room = this.friends_data.rooms[room_index]
          // 使用推送中的room数据更新原有room数据
          this.$set(this.friends_data.rooms, room_index, {
            ...room_info,
            channels: room.channels
          })
          // 如果是已有房间，调用addFriendToRoom添加即可
          addFriendToRoom(room, channel_id)
          return
        }

        // 2. 判断新增好友所在房间是不是好友single_user_rooms数据中的已有房间
        // 如果是single_user_rooms中，说明这个房间只有一个好友在线，在添加了新的好友后，这个房间就有两个好友在线了
        // 所以要从single_user_rooms数组转移到rooms数组
        let single_room_index = this.friends_data.single_user_rooms.findIndex(v => v.room_id === room_id)
        if (single_room_index >= 0) {
          let room = this.friends_data.single_user_rooms.splice(single_room_index, 1)[0]
          room = {
            ...room_info,
            channels: room.channels
          }
          addFriendToRoom(room, channel_id)

          this.friends_data.rooms.push(room)
          this.friends_data.rooms.sort(this.friendRoomAndChannelSortFunc)
          return
        }

        // 3. 增好友所在房间不是已有的房间数据，根据是不是只有一个好友的房间，添加到对应的数组中
        if (isSingleUser(room_info.channels)) {
          this.friends_data.single_user_rooms.push(room_info)
          this.friends_data.single_user_rooms.sort(this.friendRoomAndChannelSortFunc)
        } else {
          this.friends_data.rooms.push(room_info)
          this.friends_data.rooms.sort(this.friendRoomAndChannelSortFunc)
        }
      }
    },

    friendSortFunc(a, b) {
      let a_user_state = a.user_state || {
        game_name: '',
        music_name: '',
      }
      let b_user_state = b.user_state || {
        game_name: '',
        music_name: '',
      }
      if ((a_user_state.game_name) === (b_user_state.game_name)) {
        if (a_user_state.music_name === b_user_state.music_name) {
          return b.nickname > a.nickname ? 1 : -1
        } else {
          if (b_user_state.music_name > a_user_state.music_name) return 1
          if (b_user_state.music_name == a_user_state.music_name) return 0
          if (b_user_state.music_name < a_user_state.music_name) return -1
        }
      } else {
        if (b_user_state.game_name > a_user_state.game_name) return 1
        if (b_user_state.game_name == a_user_state.game_name) return 0
        if (b_user_state.game_name < a_user_state.game_name) return -1
      }
    },
    friendRoomAndChannelSortFunc(a, b) {
      return b.last_join_time - a.last_join_time
    },
    ...mapMutations([
      'SET_FRIENDS',
    ]),
  },
}
